export const ctaKey = 'czt-newsletter-cta';
export const subscribedKey = `${ctaKey}__subscribed`;

export const CTATimeout: number = 3;
